<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 -960 960 960"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="`width: ${size}px; height: ${size}px;`"
    >
        <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "ArrowIcon",
        props: {
            size: {
                type: Number,
                default: 18
            }
        }
    }
</script>